import { createFileRoute } from '@tanstack/react-router'

import { TemplatesSection } from '@/features/organization/templates-section'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute('/_app/organizacao/templates')({
  component: TemplatesTab,
})

function TemplatesTab() {
  const { currentOrgId } = useAuth()
  return <TemplatesSection orgId={currentOrgId} />
}
